import React, { useCallback, useEffect, useState, useRef } from "react"
import { Alert, Card, CardBody, Col, Container, Row } from "reactstrap"
import {loginAction, validateEmail} from "../../store/actions/authActions";
import { useDispatch, useSelector } from "react-redux";
import logo from './../../assets/images/logo-dark.svg';
import { showLoader } from "../../store/actions/mainActions";

export const Login = (props) => {
  const initialLoginState = {
    username: '',
    password: '',
    otp: '',
    rememberme: false,
    error: ''
  }
  const [state, setState] = useState(initialLoginState);
  const [loginSuccess, setLoginSuccess] = useState(false);
  const [emailVerified, setEmailVerified] = useState(false);
  const { me } = useSelector((state) => state.auth)
  const dispatch = useDispatch();
  const { history } = props;
  const otpInputRef = useRef(null);

  const afterLogin = useCallback(() => {
    if (me !== null && localStorage.getItem('token')) {
      history.push('/');
    }
  }, [history, me])

  useEffect(() => {
    afterLogin();
  }, [me, afterLogin])

  useEffect(() => {
    if (emailVerified && otpInputRef.current) {
      otpInputRef.current.focus();
    }
  }, [emailVerified]);

  const verifyEmail = async () => {
    try {
      if (!state.username.trim()) {
        setState({ ...state, error: 'Username is required' });
        return;
      }

      dispatch(showLoader(true));
      dispatch(validateEmail(state.username)).then((res) => {
        dispatch(showLoader(false));
        setEmailVerified(res);
        if(!res) {
          setState({ ...state, error: 'Please provide valid credentials' });
        } else {
          setState({ ...state, error: '' });
        }
      });

    } catch (err) {
      dispatch(showLoader(false));
      setState({ ...state, error: err?.message });
    }
  }

  const login = async () => {
    try {
      if (validSubmit()) {
        dispatch(showLoader(true));
        const res = await dispatch(loginAction(state.username, state.password));
        if (res.error) {
          setState({ ...state, error: 'Please provide a valid 5 digits OTP' });
        } else {
          setState({ ...state, error: '' });
        }
      }
    } catch (err) {
      setState({ ...state, error: err?.message });
    } finally {
      dispatch(showLoader(false));
    }
  }

  const setLoginState = (key, value) => {
    const newState = { ...state };
    newState[key] = value;
    setState(newState);
  }

  const validSubmit = () => {
    if (state.username && state.password) {
      setLoginState('error', '')
      return true
    }
    setLoginState('error', 'Please provide valid credentials')
    return false
  }

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (emailVerified) {
      login();
    } else {
      verifyEmail();
    }
  }

  return <React.Fragment>
    <div className="account-pages my-5 pt-sm-5">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={5}>
            <Card className="overflow-hidden">
              <div className="bg-primary bg-soft px-3">
                <Row className={'py-3 row flex-column justify-content-center align-items-center'}>
                  <Col className="col-6">
                    <div className="text-primary text-center">
                      <p>Sign in</p>
                      <h5 className="text-primary">Hartman Connect Admin</h5>
                    </div>
                  </Col>
                  <Col className="col-6 align-self-center py-3">
                    <img src={logo} alt="" className="img-fluid" />
                  </Col>
                </Row>
              </div>
              <CardBody className="pt-0">
                <div className="auth-logo">
                  <a href="/" className="auth-logo-light">
                    <div className="avatar-md profile-user-wid mb-4">
                      <span className="avatar-title rounded-circle bg-light">
                        <img
                          src={''}
                          alt=""
                          className="rounded-circle"
                          height="34"
                        />
                      </span>
                    </div>
                  </a>
                </div>
                <div className="p-2">
                  <form
                      className="form-horizontal"
                      onSubmit={handleFormSubmit}
                  >
                    {state.error && state.error.length > 0 ? (
                        <Alert color="danger">{state.error}</Alert>
                    ) : null}

                    {!loginSuccess &&
                        <div>
                          <div className="mb-3">
                            <input
                                label="Email"
                                value={state.username}
                                onChange={(e) => setLoginState('username', e.target.value)}
                                className="form-control"
                                placeholder="Enter your email"
                                type="email"
                                disabled={emailVerified}
                            />
                          </div>
                          {emailVerified &&
                              <div className="mb-3">
                                <input
                                    ref={otpInputRef}
                                    label="One time code"
                                    type="text"
                                    className="form-control"
                                    placeholder="Please enter the one time code (OTP) you received"
                                    value={state.password}
                                    onChange={(e) => setLoginState('password', e.target.value)}
                                />
                              </div>
                          }

                          <div className="mt-3 d-grid">
                            <button
                                type="submit"
                                className="btn btn-primary btn-block"
                            >
                              {'Log In'}
                            </button>
                          </div>
                        </div>
                    }
                  </form>
                </div>
              </CardBody>
            </Card>
            <div className="mt-5 text-center">
              <p>
                © {new Date().getFullYear()} SHALOM HARTMAN INSTITUTE. All rights reserved
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  </React.Fragment>
}